"use client"

import { AnimatedNumber } from "@opensea/ui-kit"
import { useCallback } from "react"
import { useContextSelector } from "use-context-selector"
import { AsteriskText } from "@/components/profile/AsteriskText"
import { ProfileSettingsContext } from "@/components/profile/ProfileSettingsProvider"

/**
 * Shared hook for rendering USD balance with privacy setting support
 */
export function useRenderUsdBalance() {
  const hideWalletWorth = useContextSelector(
    ProfileSettingsContext,
    state => state.hideWalletWorth,
  )

  const renderUsdBalance = useCallback(
    (value: number | undefined) => {
      if (hideWalletWorth) {
        return <AsteriskText />
      }
      return <AnimatedNumber display="usd" value={value} />
    },
    [hideWalletWorth],
  )

  return renderUsdBalance
}
